const validateEmailFormat = (email) => {
  const reg = new RegExp(
    [
      '^(([^<>()[\\]\\\\.,;:\\s@"]+(\\.[^<>()[\\]\\\\.,;:\\s@"]+)*)',
      '|(".+"))@((\\[[0-9]{1,3}\\.[0-9]{1,3}\\.[0-9]{1,3}\\.[0-9]{1,3}\\])|(([a-zA-Z\\-0-9]+\\.)',
      '+[a-zA-Z]{2,}))$',
    ].join('')
  )
  return reg.test(email)
}

function findLowestCheckedValue(stopsFilter) {
  const checkedItems = stopsFilter.filter((item) => item.checked)
  if (checkedItems.length === 0) {
    // The backend requires null to be treated as an unfiltered search.
    return null
  }
  return String(Math.min(...checkedItems.map((item) => parseInt(item.value, 10))))
}

export { validateEmailFormat, findLowestCheckedValue }
